import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { localizable } from '../../../components/Localization';

import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';

@localizable
@observer
class NotificationsPanel extends Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
  };

  handleClose = () => {
    const { onClose } = this.props;
    if (onClose) {
      onClose();
    }
  };

  handleChange = (i) => (_, checked) => {
    const { sale } = this.props;

    sale.notifications[i].enabled = checked;
    sale.changeNotificationSettings();
  };

  render() {
    const { t, sale } = this.props;

    return (
      <Panel
        headerText={t('Notifications')}
        type={PanelType.medium}
        isOpen={this.props.isOpen}
        onDismissed={this.handleClose}
        onRenderFooterContent={this.renderPanelFooterContent}
        isFooterAtBottom={true}
        closeButtonAriaLabel={t('Close')}
      >
        <Fragment>
          <p>{t('Explanation')}</p>

          <table style={{ width: '100%' }}>
            <thead>
              <tr>
                <th style={{ textAlign: 'left' }}>{t('Active')}</th>
                <th style={{ textAlign: 'left' }}>{t('Recipient')}</th>
                <th style={{ textAlign: 'left' }}>{t('Email')}</th>
                <th style={{ textAlign: 'left' }}>{t('Phone number')}</th>
              </tr>
            </thead>
            <tbody>
              {sale.notifications.map((n, i) => (
                <tr key={i}>
                  <td>
                    <Checkbox
                      checked={n.enabled}
                      onChange={this.handleChange(i)}
                      key="enabled"
                    />
                  </td>
                  <td style={{ paddingRight: '5px' }}>{n.name}</td>
                  <td style={{ paddingRight: '5px' }}>{n.email}</td>
                  <td>{n.phoneNumber}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Fragment>
      </Panel>
    );
  }

  renderPanelFooterContent = () => {
    const { t } = this.props;
    return (
      <div className="ms-textAlignRight">
        <DefaultButton onClick={this.handleClose}>{t('Close')}</DefaultButton>
      </div>
    );
  };
}

export default NotificationsPanel;



// WEBPACK FOOTER //
// ./src/app/containers/Sale/SaleNotificationsSection/NotificationsPanel.jsx